import React from 'react';
import { ILxsContactCardResponsibilityProps } from '../lxs-contact-page.data';

export const ResponsibilityPill: React.FC<ILxsContactCardResponsibilityProps> = ({ CLASS_NAME, items }) => {
    const renderValue = (value: string | string[]): string => {
        return Array.isArray(value) ? value.join(', ') : value;
    };

    return (
        <div className={`${CLASS_NAME}__card-partner-responsibility`}>
            {items.map((item, index) => (
                <div key={index} className={`${CLASS_NAME}__card-partner-responsibility-item`}>
                    <span className={`${CLASS_NAME}__card-partner-responsibility-item-label`}>
                        {item.label}:
                        <strong className={`${CLASS_NAME}__card-partner-responsibility-item-value`}>{renderValue(item.value)}</strong>
                    </span>
                </div>
            ))}
        </div>
    );
};

export default ResponsibilityPill;
